import { useState } from "react";

const C = {
  navyDeep:   "#f4f5f7",
  navyDark:   "#f4f5f7",
  navyMid:    "#e8eaed",
  navyBorder: "#d0d4da",
  green:      "#75BB2E",
  greenFaint: "rgba(117,187,46,0.1)",
  greenBorder:"rgba(117,187,46,0.35)",
  textPrimary:"#071D39",
  textMuted:  "#516469",
};

const BOILERPLATES = {
  buyer: [
    {
      id: "ba-offer-la",
      title: "Email to Listing Agent — Offer",
      subject: "Offer - 123 Main St, Jax, FL 32258 (Update with actual address)",
      body: `Hi (Insert agent name),

This is Lindsey Spillers with Herron! Thanks for the communication thus far.
Below is the offer summary and the list of attached documents on behalf of my buyers, XX & XXX.

OFFER SUMMARY:
Sales Price:
Closing:
Financing:
Other: Seller to contribute xx toward closing costs/prepaids

ATTACHED:
- Contract for Sale and Purchase
- GG Addendum
- Subject To Sale Addendum (CONDITIONAL)
- Contract for buyer property (CONDITIONAL)
- FHA/VA Amendatory clause (to be signed by seller and agent) (CONDITIONAL)
- HOA Addendum (to be signed by seller) (CONDITIONAL)
- Flood Disclosure (to be signed by seller)
- Compensation agreement (to be signed by seller and listing agent)
- Seller Property Disclosure (CONDITIONAL, only if not in MLS or didn't provide one)
- HRE Affiliated Business Disclosure (to be signed by seller)
- Buyer's preapproval

Please thank the sellers for their consideration of this offer and we look forward to hearing back.
Please confirm receipt of this e-mail and feel free to call, text, or email for anything. I look forward to working with you.`,
    },
    {
      id: "ba-under-contract-buyer",
      title: "Email to Buyer — Under Contract",
      subject: "Next Steps Now That You're Under Contract! 🎉",
      body: `Congratulations! You're officially under contract for the property at [ADDRESS]! 🏡 I'm excited to guide you through the process. Below are the next steps and key dates to keep in mind.

Next Steps:

Binder Deposit: Due by [DATE]. I'll include you on an email to the title company shortly so they can send you the wiring instructions. You will likely have to call them to confirm for security purposes. Their info is: {INSERT INFO HERE}

Inspection: Due by [DATE]. You have 10 days for inspections. I've included some recommended inspectors, but feel free to use your own. I can help schedule the inspection, pls lmk ASAP as they usually need a few days advance notice.

ALLSTAR HOME SOLUTIONS
Phone: 904-333-4863
Email: allstarhomeinsp@gmail.com
http://www.homegauge.com/shgi/mikeandash/

HOUSE SCAN INSPECTIONS
Phone: 904-758-9225
Email: admin@housescanfl.com
housescanfl.com/services/

Home Insurance: Required if using a mortgage. Below are my recommended agents for quotes. Please send the policy info to the lender once chosen.

GOOSEHEAD INSURANCE
Kimberlee Stuart
904-902-0211
kimberlee.stuart@goosehead.com

BRIGHTWAY INSURANCE — JIM PIHL AGENCY
3003 Claire Lane, Jacksonville, FL 32223
Michele Mcilmurray
904-262-2886
jim.pihl@brightway.com | michele.mcilmurray@brightway.com

Appraisal: Scheduled by your lender. Required for financed purchases, but not for cash deals.

Key Dates:
Contract Date: [DATE]
Binder Due: [DATE]
Title Company: [NAME]
Inspection Period: [DATES]
Closing: [DATE]
Loan Type: [TYPE]
Purchase Price: [AMOUNT]

Attached Docs:
- Executed Contract
- HOA, Flood, & Seller's Disclosures

Thank you for trusting me! Feel free to reach out if you have any questions, and I look forward to helping you every step of the way! 😊

Best,
[Your Name]`,
    },
    {
      id: "ba-under-contract-lender",
      title: "Email to Lender — Under Contract",
      subject: "New Contract — [Address]",
      body: `Hey (Loan Officer),

Offer was accepted, closing date is XX/XX.

I've attached all the necessary docs.
I've advised the buyer to send you over the homeowner insurance info once they decide on the quote.
We are working on getting the inspection on the books, will let you know once we hit that toll gate OR Inspection has been scheduled for DAY, XX/XX. Will advise once we have come to terms so you can proceed with ordering the appraisal.

Let us know if there's anything you need from us or the buyer. Looking forward to a smooth transaction!`,
    },
    {
      id: "ba-under-contract-title",
      title: "Email to Title — Under Contract",
      subject: "New Contract - XXX Address",
      body: `Hi XXX,

We went under contract on the above property yesterday. I've provided the buyer info below and cc'd them on this email. Pls send them instructions for submitting their earnest money and let us know if you need any additional info.

[Replace with correct borrower info]
Terry Hyatt - 662-812-9275, terry.m.hyatt@gmail.com
Ashleigh Hyatt - 903-818-5718, ashleigh.hyatt01@gmail.com

Thank you!!`,
    },
    {
      id: "ba-repair-req",
      title: "Email to Listing Agent — Repair Request",
      subject: "Repair Request — [Address]",
      body: `Hi (Listing Agent),

Pls see attached repair request. I've provided a copy of the full report as well as the WDO for reference. Pls discuss with your buyer and feel free to call or text with any questions/concerns.

Thank you!`,
    },
    {
      id: "ba-preclose-title",
      title: "Email to Title — Pre-Close",
      subject: "[Address]",
      body: `Hi (Name of title closer),

The lender is almost C2C on the (Buyer Last Name) file so want to confirm a few items.

- Is title ready to go? If not, what is remaining?
- Buyer will be paying the $750 transaction fee (not req'd if New Construction)
- I've attached my CDA for payment.
- Buyers want to close on (Day, xx/xx/xx, @ xx AM/PM). Pls confirm if this time slot is available.
- Pls confirm once you've advised the buyers how they need to wire their funds for closing.

Thanks in advance and have a great day!`,
    },
    {
      id: "ba-preclose-text-la",
      title: "Text to Listing Agent — Pre-Close",
      subject: "",
      body: `Hey there, I've emailed the title company about a time slot for closing on (Day of week) and requested the final walkthrough via ShowingTime.

Will you be dropping the keys/garage openers/paperwork/etc at the title company prior to? Also, what are your plans for the lockbox so I can let my buyers know. Tks and speak soon!`,
    },
    {
      id: "ba-preclose-buyer",
      title: "Email to Buyer — Pre-Close",
      subject: "Getting Ready for Closing – Next Steps & Reminders",
      body: `Hi [Buyer Name(s)],

We're in the home stretch — so exciting! As we prepare for closing, here are a few important next steps and helpful reminders to keep everything on track:

Next Steps:
- Contact the title company to confirm how they prefer to receive your funds for closing (wire, cashier's check, etc.).
- Schedule start dates for utilities (electric, water, gas, internet, etc.). I'll be attaching a list of providers for your county to make this easy.
- Final walkthrough is confirmed for Friday at 10:00 AM. We'll walk through the home to ensure it's in the agreed-upon condition prior to closing.

Helpful Reminders:
- Please bring a valid photo ID to closing.
- Avoid making any large purchases or credit changes before closing.
- Schedule movers if you haven't already.
- Set up mail forwarding with USPS and make a note to update your address with all relevant parties (drivers license, creditors, banks, et al).

Please let me know once you've completed the items above or if any questions come up. I'm here every step of the way and happy to help with anything you need.

We're almost there — can't wait to celebrate with you soon!

Best,`,
    },
    {
      id: "ba-closed-buyer",
      title: "Email to Buyer — Closed",
      subject: "XXX Address - CLOSED (PLEASE REVIEW)",
      body: `Hi XXXX,

Congratulations again on the purchase of your new home!! I am so excited for this new chapter for you/you guys!

I've attached all relevant documents on the transaction in a zip file. I would suggest creating a folder in your email where you can store this email along with all of the emails from 3rd parties (ie the appraisal, inspection, wind mit, etc). To be extra cautious, you should download them into a cloud based document storage for quick and easy access. 🙂

Lastly, we would greatly appreciate a review from you/each of you on our Google & Facebook business pages. This helps promote our brand awareness and gives other potential customers insight on how we do business. You can access the reviews here:

Google: https://g.page/r/CZaNIsQKxvVIEBM/review
Facebook: Lindsey Spillers, Realtor | Facebook`,
    },
  ],
  listing: [
    {
      id: "la-offer-seller",
      title: "Email to Seller — Offer Received",
      subject: "XXX Property Address - OFFER RECEIVED",
      body: `CONGRATULATIONS!!! We just received an offer on your property!

The offer is for $225,000.00 with conventional financing.
Buyer will deposit $2,500.00 with (name of title company).
Seller to pay for Title Policy.
Buyer accepts property as is/requests xx days for an inspection (ONE OR THE OTHER).
Seller to pay $525 for a one-year home warranty. (CONDITIONAL)
Closing on or before 10/2/2020
Seller to contribute $0.00 towards buyer's closing costs
Refrigerator, Stove, Dishwasher to convey with the sale (CONDITIONAL)

At the $225,000.00 sales price, with all the above terms, your estimated net proceeds would be $211,500.00 (this amount DOES NOT include any taxes that may be owed, any proration of taxes for the current year, or any mortgage payoffs).

Let's set a time to talk as soon as possible. You'll want to have the offer pulled up on your computer, preferably not your phone, and be somewhere we can talk without distractions. Looking forward to talking it through!

Congratulations again,`,
    },
    {
      id: "la-offer-ba",
      title: "Email to Buyer's Agent — Offer Accepted",
      subject: "XXX Property Address - CONGRATULATIONS!",
      body: `Good Afternoon/Morning,

Please see attached executed contract and relevant addenda. Instructions for EMD are below. Thanks again and I look forward to working with you to ensure a smooth and successful transaction. :)

IF BLUE OCEAN, USE BELOW:
Earnest Money Deposit/Binder:
For your convenience, we offer 3 ways to submit your earnest money deposit/binder!

1. Online through our website via electronic check. (Up to 20k can be sent at one time) Quick, simple and free! Click the link below to get started!
https://payclix.com/blueoceantitlejacksonvillestaugustine/index.cfm
Once the deposit has been submitted, a verification of binder receipt will be issued. Should you have any questions or concerns regarding the electronic check, please e-mail admin@blueoceantitle.com

2. Binder deposit may be wired. Please email admin@blueoceantitle.com to receive the wiring instructions.

3. A check or money order may be dropped off at one of our office locations.
- Jacksonville: 4309 Pablo Oaks Ct., Suite 4, Jacksonville, FL 32224

IF LANDMARK, USE BELOW:
Earnest Money Deposit/Binder:
You can either wire funds or drop a check off to the address on the purchase contract. The title company will be reaching out to your buyers via email with wiring instructions and more information.`,
    },
    {
      id: "la-new-listing-title",
      title: "Email to Title — New Listing",
      subject: "NEW CONTRACT - Address",
      body: `Good Morning/Afternoon,

I have a new listing that will be closing with your office. I've attached the executed contract and addressed the below questions. Please let me know if you need anything further.

What is your commission for each side for this property: LA 2.5% / BA 2.5%
Do you charge a transaction / brokerage fee: $750
Is this a mailaway? No
Sellers e-mail AND phone #:
Christin Smith, christin.smith92@yahoo.com, 321-720-8263
Seller #2:
Buyers email address: xxx@gmail.com
Do you have the existing survey you can scan to me WITH NO CHANGES to the property (add or remove a fence, pool, shed, patio)? The Seller will be signing an affidavit at closing stating this. Or we need to order a NEW one. Yes
HOA Company Info: Freedom, 904-490-8191, customercare@fcmjax.com`,
    },
    {
      id: "la-preclose-title",
      title: "Email to Title — Pre-Close",
      subject: "[Address]",
      body: `Hi (Name of title closer),

The lender is almost C2C on the (Seller Last Name) file so want to confirm a few items.

- Is title ready to go? If not, what is remaining?
- Seller will be paying the $750 transaction fee (not req'd if New Construction)
- I've attached my CDA for payment.
- Sellers want to close on (Day, xx/xx/xx, @ xx AM/PM). Pls confirm if this time slot is available.
- Pls confirm once you've received the info from the sellers on how they expect their funds.

Thanks in advance and have a great day!`,
    },
    {
      id: "la-closed-seller",
      title: "Email to Seller — Closed",
      subject: "XXX Address - CLOSED (PLEASE REVIEW)",
      body: `Hi XXXX,

Congratulations again on the sale of your home!! I am so excited for this new chapter for you/you guys!

I've attached all relevant documents on the transaction in a zip file. I would suggest creating a folder in your email where you can store this email along with all of the emails from 3rd parties (ie the appraisal, inspection, wind mit, etc). To be extra cautious, you should upload them into a cloud based document storage for quick and easy access. 🙂

DO NOT FORGET TO UPDATE YOUR ADDRESS WITH YOUR LENDER AND INSURANCE COMPANY AND CANCEL YOUR INSURANCE POLICY, EFFECTIVE TODAY!

Lastly, we would greatly appreciate a review from you/each of you on our Google & Facebook business pages. This helps promote our brand awareness and gives other potential customers insight on how we do business. You can access the reviews here:

Google: https://g.page/r/CZaNIsQKxvVIEBM/review
Facebook: Lindsey Spillers, Realtor | Facebook`,
    },
  ],
  general: [
    {
      id: "hoa-email",
      title: "Email to HOA / Property Management",
      subject: "[Property Address] — HOA Documents Request",
      body: `Good Morning/Afternoon,

I am the realtor for the above referenced property, located in xxx (Subdivision). Could you pls forward over the below and advise if this is also the correct email for HOA Estoppel requests?

- Bylaws
- Rules and Regulations
- Covenants, Conditions and Restrictions
- Articles of Incorporation
- Most recent year-end financial statements

Many thanks in advance. :)`,
    },
    {
      id: "fb-review-ask",
      title: "FB Review Ask",
      subject: "",
      body: `Hey there, would you mind doing me a huge favor? I need to increase my ratings on FB so I'm going to paste your Google review below? Can you pls just go to my business page and paste this in the review section? I would REALLY appreciate it!

Spillers Realty Group | Facebook`,
    },
    {
      id: "homestead-exemption",
      title: "Homestead Exemption Reminder",
      subject: "Homestead Exemption Reminder",
      body: `Hi,

This is your friendly reminder to file your homestead exemption if you haven't already. Deadline for filing with your county is March 1st.

Links to the sites are below!

Duval: Jacksonville.gov - Property Appraiser
Clay: Exemptions Information – Office of the Clay County Property Appraiser – Tracy Scott Drake
Nassau: Nassau County Property Appraiser
St Johns: New Online Exemption Application Now Available - Saint Johns County Property Appraiser

Hope all is well and hope to see you soon!

Best,`,
    },
  ],
};

const CATEGORIES = [
  { id: "buyer",   label: "Buyer Agent",    icon: "🔑" },
  { id: "listing", label: "Listing Agent",  icon: "🏡" },
  { id: "general", label: "General",        icon: "📬" },
];

export default function BoilerplatesTab() {
  const [activeCategory, setActiveCategory] = useState("buyer");
  const [expanded, setExpanded] = useState(null);
  const [copied, setCopied] = useState(null);

  const handleCopy = (id, text, subject) => {
    const full = subject ? `SUBJECT: ${subject}\n\n${text}` : text;
    navigator.clipboard.writeText(full).then(() => {
      setCopied(id);
      setTimeout(() => setCopied(null), 2000);
    });
  };

  const items = BOILERPLATES[activeCategory] || [];

  return (
    <div style={{ padding: "0 0 32px" }}>
      {/* Category tabs */}
      <div style={{
        display: "flex",
        gap: 8,
        padding: "12px 12px 0",
        backgroundColor: C.navyDark,
        borderBottom: `2px solid ${C.navyBorder}`,
      }}>
        {CATEGORIES.map(cat => (
          <button
            key={cat.id}
            onClick={() => { setActiveCategory(cat.id); setExpanded(null); }}
            style={{
              display: "flex", alignItems: "center", gap: 6,
              padding: "8px 16px",
              background: activeCategory === cat.id ? C.navyMid : "transparent",
              border: "none",
              borderRadius: "8px 8px 0 0",
              borderBottom: activeCategory === cat.id ? `2px solid ${C.green}` : "2px solid transparent",
              color: activeCategory === cat.id ? "#ffffff" : C.textMuted,
              fontSize: 13, fontWeight: activeCategory === cat.id ? 700 : 500,
              cursor: "pointer", fontFamily: "inherit",
              marginBottom: -2,
            }}
          >
            <span>{cat.icon}</span>
            {cat.label}
          </button>
        ))}
      </div>

      {/* Boilerplate list */}
      <div style={{ padding: "16px 12px", display: "flex", flexDirection: "column", gap: 8 }}>
        {items.map(item => (
          <div
            key={item.id}
            style={{
              background: C.navyDark,
              border: `1px solid ${expanded === item.id ? C.green : C.navyBorder}`,
              borderRadius: 10,
              overflow: "hidden",
              transition: "border-color 0.15s",
            }}
          >
            {/* Header row */}
            <div
              onClick={() => setExpanded(expanded === item.id ? null : item.id)}
              style={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                padding: "14px 16px", cursor: "pointer",
              }}
            >
              <div>
                <div style={{ fontSize: 14, fontWeight: 700, color: C.textPrimary }}>
                  {item.title}
                </div>
                {item.subject ? (
                  <div style={{ fontSize: 11, color: C.textMuted, marginTop: 2 }}>
                    Subj: {item.subject}
                  </div>
                ) : (
                  <div style={{ fontSize: 11, color: C.textMuted, marginTop: 2 }}>Text / No subject</div>
                )}
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <button
                  onClick={(e) => { e.stopPropagation(); handleCopy(item.id, item.body, item.subject); }}
                  style={{
                    padding: "6px 14px",
                    background: copied === item.id ? C.green : C.greenFaint,
                    border: `1px solid ${C.greenBorder}`,
                    borderRadius: 6,
                    color: copied === item.id ? C.navyDeep : C.green,
                    fontSize: 12, fontWeight: 700,
                    cursor: "pointer", fontFamily: "inherit",
                    transition: "all 0.15s",
                    whiteSpace: "nowrap",
                  }}
                >
                  {copied === item.id ? "✓ Copied!" : "Copy"}
                </button>
                <span style={{ color: C.textMuted, fontSize: 16 }}>
                  {expanded === item.id ? "▲" : "▼"}
                </span>
              </div>
            </div>

            {/* Expanded body */}
            {expanded === item.id && (
              <div style={{
                borderTop: `1px solid ${C.navyBorder}`,
                padding: "16px",
                background: C.navyMid,
              }}>
                {item.subject && (
                  <div style={{
                    fontSize: 12, fontWeight: 700, color: C.green,
                    marginBottom: 10, letterSpacing: "0.5px",
                  }}>
                    SUBJECT: {item.subject}
                  </div>
                )}
                <pre style={{
                  fontSize: 12, color: C.textMuted,
                  whiteSpace: "pre-wrap", wordBreak: "break-word",
                  fontFamily: "inherit", lineHeight: 1.7, margin: 0,
                }}>
                  {item.body}
                </pre>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}